export const getCommonParams = (modelId?: number) => ({
  models: modelId,
  active: true,
  'expand[]': ['accessories', 'model'],
  sort: 'priceCents',
  pageSize: -1
});
